<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer030">
<p class="Prelims-head" id="_idParaDest-1"><a id="_idTextAnchor000"></a>About the Author</p>
<p class="Prelims-main"><img alt="" class="_idGenObjectAttribute-1" src="image/JAMES-Paul-author.jpg"/></p>
<p class="Prelims-main">Paul James hails from Yorkshire and is now settled in London. He has led an eclectic mix of an existence, living and working on four continents. A former military man; aircraft engineer; semi-pro footballer; national security consultant; international businessman; poet and published author, Paul is an incurable primeval Scorpio romantic, with an artistic penchant for the ocean-deep intensity and surreal dark side in his writing, where he pushes the boundaries of poetic prose. His passionate nature and old-fashioned soul are as prevalent in his life as they are in his studious work, showcased in this unique poetry collection.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781788480116_EPUB.vue?26192dc6